//Handles Mobile Menu functionality
$(document).ready(function () {
	let mobile_menu_open = false;
	const $menu_btn = $('header button.mobile-menu-button');
	const $nav = $('header .menu-wrapper');
	const $nav_primary_li = $('.menu > li > a');
	const desktop_only_width = 1400; // make sure this matches $header_breakpoint_desktop on header.scss
	const toggle_dropdown_menu_class = 'open-sub-menu';
	const toggle_dropdown_body_class = 'desktop-dropdown-open';

	// close the click menu
	const header_sub_menu_hide = function () {
		$nav_primary_li.parent('li').removeClass(toggle_dropdown_menu_class);
		// $nav_primary_li.parent('li').find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
		$nav_primary_li.attr('aria-expanded', 'false');
		$('body').removeClass(toggle_dropdown_body_class);
	};

	const header_mobile_show = function ($element) {
		$element.find('.hamburger').addClass('is-active'); //activates hamburger nav menu animation
		$('body').addClass('nav-open');
		mobile_menu_open = true;
	};

	const header_mobile_hide = function ($element) {
		$element.find('.hamburger').removeClass('is-active'); //removes hamburger nav menu animation
		$('body').removeClass('nav-open');
		mobile_menu_open = false;
	};

	const aquamin_header = function () {
		// mobile menu and resizing
		$(window).on('resize', function () {
			if (
				$(this).width() < desktop_only_width &&
				$nav.hasClass('keep-open')
			) {
				$nav.removeClass('keep-open').hide();
			}
			if (
				$menu_btn.is(':hidden') &&
				$nav.is(':hidden') &&
				$(window).width() > desktop_only_width - 1
			) {
				$nav.addClass('keep-open').show();
			}
		});

		// mobile menu button
		$menu_btn.on('click touch', function () {
			if (mobile_menu_open === false) {
				header_mobile_show($(this));
			} else {
				header_mobile_hide($(this));
			}
		});

		//disable header clases if main is clicked
		$(document).on('click touch', 'main, footer', function () {
			header_sub_menu_hide();
		});
	};

	$(document).ready(function () {
		aquamin_header();
	});
});
